import { callerName } from '@nzyme/ioc/helpers/callerName.js';
import { defineService } from '@nzyme/ioc/Service.js';
import { LoggerTransport } from './LoggerTransport.js';
/**
 * A logger interface.
 */
export const Logger = defineService({
    name: 'Logger',
    resolution: 'transient',
    deps: {
        name: callerName(),
        transport: LoggerTransport,
    },
    setup: ({ name, transport }) => {
        const logger = {
            name,
            error: (msg, obj) => transport(name, 'error', msg, obj),
            warn: (msg, obj) => transport(name, 'warn', msg, obj),
            info: (msg, obj) => transport(name, 'info', msg, obj),
            debug: (msg, obj) => transport(name, 'debug', msg, obj),
            trace: (msg, obj) => transport(name, 'trace', msg, obj),
        };
        return logger;
    },
});
//# sourceMappingURL=Logger.js.map